import { createSlice } from "@reduxjs/toolkit";
import type { CatalogTundishShroud } from "../../../models/CatalogTundishShroud";

const CatalogTundishShroudInitialState: {
  tundishShrouds: CatalogTundishShroud[] | null;
} = {
  tundishShrouds: null,
};

export const CatalogTundishShroudReducer = createSlice({
  name: "__",
  initialState: CatalogTundishShroudInitialState,
  reducers: {
    setTundishShrouds(state, { payload }) {
      state.tundishShrouds = payload;
    },
  },
});
